import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deactivateContract } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractDeactivate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deactivateContract,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queries.contracts._def }),
    });
};
